<template>
  <DBox
    :id="'cmp-booking-venues-sidewindow-communication'"
    :addButton="false"
    :addLink="false"
  >
    <div class="form-group">
      <TextField2
        :id="'phone1'"
        v-bind="textFieldConfig"
        :value="location.phone1"
        :placeholder="$t('phone1')"
        :label="$t('phone1')"
        @blur="onTextFieldValueChange"
      />
      <TextField2
        :id="'fax'"
        v-bind="textFieldConfig"
        :value="location.fax"
        :placeholder="$t('fax')"
        :label="$t('fax')"
        @blur="onTextFieldValueChange"
      />
      <TextField2
        :id="'email'"
        v-bind="textFieldConfig"
        :value="location.email"
        :placeholder="$t('email')"
        :label="$t('email')"
        @blur="onTextFieldValueChange"
      />
      <TextField2
        :id="'url1'"
        v-bind="textFieldConfig"
        :value="location.url1"
        :placeholder="$t('url1')"
        :label="$t('url1')"
        @blur="onTextFieldValueChange"
        bb="0px"
      />
    </div>
  </DBox>
</template>

<script>
import DBox from "@dtplugins/dbox/dbox";
import { EventHooks } from "../../../../plugins/text-field";
export default {
  components: {
    DBox
  },
  props: {
    venue: {
      type: Object,
      required: true
    }
  },
  data: function() {
    return {
      textFieldConfig: {
        showEditIconOnHover: false,
        showValidationIcons: false,
        validationEvent: EventHooks.OnBlur,
        valueChangedEvent: EventHooks.OnBlur
      }
    };
  },
  computed: {
    location: function() {
      return this.venue.location;
    }
  },
  methods: {
    onTextFieldValueChange: function({ name, value }) {
      this.$emit("changed", { name, value });
    }
  }
};
</script>

<style lang="scss" scoped>
.cmp-booking-venues-sidewindow-communication {
  .form-group .input_box {
    padding: 0px 5px;
  }
}
</style>
